/**
 * CNC Infinite Scroll (lazy-load) — auto-loads the next page as the user nears the
 * bottom and appends products to the grid. Dawn's numbered pagination is the data
 * source (rendered, then hidden here). Card images stay lazy (loading="lazy").
 *
 * Uses a scroll-position trigger (robust) rather than an IntersectionObserver sentinel.
 * Dawn quirk: the NEXT-page link carries class `pagination__item--prev` and has no
 * rel="next" — that's why the previous selector never matched and it never advanced.
 */
(function () {
  const GRID = '#product-grid';
  const ITEM = '#product-grid .grid__item';
  const PAG = '.pagination';
  let loading = false;
  let done = false;

  const nextUrl = () => {
    const p = document.querySelector(PAG);
    const a = p && p.querySelector('a.pagination__item--prev[href]');
    return a ? a.href : null;
  };
  const hidePag = () => { const p = document.querySelector(PAG); if (p) p.style.display = 'none'; };
  // Fire when the bottom of the GRID nears the viewport — NOT the document bottom
  // (a tall footer sits below the grid, so document-distance fired far too late / not at all).
  const nearBottom = () => {
    const grid = document.querySelector(GRID);
    if (!grid) return false;
    return grid.getBoundingClientRect().bottom <= window.innerHeight + 800;
  };

  function maybeLoad() {
    if (loading || done) return;
    if (!nearBottom()) return;
    const url = nextUrl();
    if (!url) { done = true; return; }
    loading = true;
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = document.querySelector(GRID);
        if (grid) doc.querySelectorAll(ITEM).forEach((it) => grid.appendChild(it));
        const p = document.querySelector(PAG);
        const np = doc.querySelector(PAG);
        if (p && np) p.innerHTML = np.innerHTML;
        hidePag();
        loading = false;
        if (!nextUrl()) { done = true; } else { maybeLoad(); }
      })
      .catch(() => { loading = false; });
  }

  function init() {
    if (!document.querySelector(GRID)) return;
    hidePag();
    if (!nextUrl()) return;
    window.addEventListener('scroll', maybeLoad, { passive: true });
    window.addEventListener('resize', maybeLoad, { passive: true });
    maybeLoad(); // in case the first page already sits near the bottom
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
